import '../css/main.css';
import '@fontsource/dm-mono';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
    .register(new URL('./serviceWorker.js', import.meta.url))
    .catch(err => {
      console.warn('Service worker registration failed:', err);
    });
  });
}
